// @shared/utils/howToPlayUtils.js

export const HOW_TO_PLAY = {
  title: "How To Play",
  sections: [
    {
      heading: "Objective",
      content: `Eliminate your opponents by reducing their Character Card's health to zero. Use Infinity Cards to attack, defend, buff, or disrupt. The last player standing wins the match.`,
    },
    {
      heading: "Turn Structure",
      content: `Each player gets 2 actions per turn. Available actions:
      - Attack another player
      - Play a card
      - Discard a card
      - Trade a card
      *Note: You can't perform the same action twice in a single turn (e.g., no double attacks).*
      After using your actions, your hand is refilled to 5 cards.`,
    },
    {
      heading: "Combat Rules",
      content: `To attack:
      - Choose a target
      - Use the Spin Wheel to determine the attack's outcome
      - If the result is ≤ your Character's Accuracy, the attack lands
      - If the result = Accuracy exactly, it's a *Critical Hit* and deals bonus damage
	 - If the elenment of your Character affects the target's, it's a *Elemental Hit* and deals bonus damage
	  - If the result > Accuracy, the attack misses


      If a target is in Defense Mode, their Shield absorbs damage before Health.`,
    },
    {
      heading: "Defense Mode",
      content: `You may choose to enter Defense Mode at the start of your turn. While in this mode:
      - You cannot attack
      - Your shield must be above 0
      - All incoming attacks reduce Shield first`,
    },
    {
      heading: "Card Types",
      content: `- **Attack Cards:** Add damage to your next attack
      - **Shield Cards:** Restore shield
      - **Buff Cards:** Temporarily boost Accuracy or Attack
      - **Disrupt Cards:** Affect enemy cards, force discards, etc.

      *Most buffs expire after your next attack.*`,
    },
  ],
};

export const LEVELING_AND_REWARDS = {
  title: "Leveling & Rewards",
  sections: [
    {
      heading: "XP System",
      content: `Earn XP from the following actions:
      - Dealing Damage: +10
      - Eliminations: +10 * Damage dealt
      - Playing Cards: +5
      - Discards: +5
      - Trades: +2
	  - Placement: 3rd - +50, 2nd - +70, 1st - +100`,
    },
    {
      heading: "Level Tiers",
      content: `Your level determines your title and badge:

      - Bronze: 1 - 24
      - Silver: 25 - 49
      - Gold: 50 - 64
      - Elite: 65 - 74
      - Legend: 75 - 84
      - Mythic: 85 - 99
      - Infinity Master Tier 1: M1
      - Infinity Master Tier 2: M2+`,
    },
    {
      heading: "Rewards",
      content: `- Leveling up grants XP, Infinity Tokens, Packs, Cosmetics and occasionally exclusive Cards.
      - Special Quests also unlock at major level milestones.`,
    },
  ],
};

export const STRATEGY_GUIDE = {
  title: "Battle Strategy",
  sections: [
    {
      heading: "Play Styles",
      content: `- **Aggressive:** Focus on early attacks, critical hits, and momentum
      - **Defensive:** Cycle cards, maintain shield, play for Top 3 placement
      - **Disruptive:** Interrupt enemy strategies with debuffs and discards`,
    },
    {
      heading: "Tips",
      content: `- Don’t waste a turn if you don’t have an optimal play—discard to cycle
      - Pay attention to opponent hand size and stance
      - Use trades to get crucial missing pieces before your combo turn`,
    },
    {
      heading: "Advanced Tactics",
      content: `- Bait opponents by staying just above 0 Shield
      - Stack temporary buffs before attacking
      - Track card types you've seen to anticipate remaining deck cards`,
    },
  ],
};

export const DECK_BUILDING = {
  title: "Deck Building",
  sections: [
    {
      heading: "Overview",
      content: `Each deck contains 40 cards used to assist your and 1 Character card. Your strategy should depend on your character's base stats - so build carefully!`,
    },
    {
      heading: "Card Limits",
      content: `- Infinity Cards have a certain limit of copies per deck, indicated by the number in the bottom right corner.
- The amount of copies of a card in your deck must be equal to or less than that limit.`,
    },
    {
      heading: "Tips",
      content: `- Balance between attack, defense, support, and trap cards.
- Include card cycle options (draw/discard)
- Build with synergy in mind (buff + attack combos)`,
    },
  ],
};

export const QUESTING = {
  title: "Questing",
  sections: [
    {
      heading: "Daily & Weekly Quests",
      content: `Quests offer XP, Tokens, and Pack rewards for completing specific objectives like:
- Play X number of matches
- Use specific card types
- Win with a specific character element type`,
    },
    {
      heading: "Tracking Progress",
      content: `Your quest progress is tracked automatically.
Complete them before they expire to claim rewards.`,
    },
    {
      heading: "Strategy",
      content: `Combine quests with your usual playstyle. For example, if a quest rewards using attack cards — build your deck accordingly that day.`,
    },
  ],
};
